/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateDataInterviewBadgeStateSchema = z.enum([
	'confirmed',
	'pending',
	'completed',
	'no_show',
	'expired',
	'cancelled',
])

export type CandidateDataInterviewBadgeStateSchema = z.infer<typeof candidateDataInterviewBadgeStateSchema>
